<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModalExames"
            title="Confirmação do agendamento de exame"
        >
            <rkm-alert show info>
                <strong>
                    {{itemSelecionado.data}} -
                    {{ getStringDiaSemana(itemSelecionado.semanaId) }}
                </strong>
            </rkm-alert>

            <Cotas
                :itemSelecionado="itemSelecionado"
                :agendamento="agendamento"
                @handleSaldo="handleSaldo"
            />

            <Form
                ref="Form"
                :paciente="paciente"
                :data="data"
                :itemSelecionado="itemSelecionado"
                :verificaAutorizacao="verificaAutorizacao"
                :agendamento="agendamento"
                :jornadas="jornadas"
                :vagas="vagas"
                :horarioAgendamento="horarioAgendamento"
                :cota="cota"
                :regulacaoSolicitacao="regulacaoSolicitacao"
                :reagendar="reagendar"
                @horariosDisponiveis="handleHorariosDisponiveis"
                @handleAgendamento="handleAgendamento"
                @handleAutoriza="handleAutoriza"
                @handleExit="handleExit"
            />

            <template v-slot:footer="{ cancel }">

                <rkm-button @click="cancel">
                    Voltar
                </rkm-button>

                <rkm-button
                    @click.stop="validate"
                    color="primary"
                >
                    Confirmar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalPermissao
            ref="RkmModalPermissao"
            @saveModal="saveModal"
            @handleExitSupervisor="handleExit"
            :origem="origem"
        />
    </div>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

//Components.
import Form from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/exames/Form'
import Cotas from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/cotas/Form'
import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'

//Enums
import tipoJornada from '@/enums/exame-laboratorial/tipoJornada'
import diasSemana from '@/enums/exame-laboratorial/diasSemana'

// Moment.
import moment from 'moment'

export default {
    components: { Form, Cotas, ModalPermissao },
    data: () => ({
        verificaAutorizacao: false,
        index: null,
        item: null,
        enums: {
            tipoJornada,
            diasSemana,
        },
        horarioAtendimento: null,
        itemSelecionado: [],
        cota: {},
        exames: [],
        disponivel: true,
        horariosDisponiveis: true,
        autoriza: false,
        origem: 'vagas'
    }),
    methods: {
        open(diaSelecionado, verificaAutorizacao) {

            if (verificaAutorizacao == false) {

                this.verificaAutorizacao = true
            }

            this.itemSelecionado = diaSelecionado

            this.$refs.RkmModalExames.show()
        },
        handleExit() {

            this.$refs.RkmModalExames.hide()
        },
        handleAgendamento(value, horario){

            this.exames = value
            this.agendamento.incluido = value
            this.horarioAtendimento = horario
        },
        handleHorariosDisponiveis(horarios){

            this.horariosDisponiveis = horarios
        },
        handleAutoriza(){

            this.autoriza = true
        },
        validate(){

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                if (this.exames.length == 0 && this.agendamento.incluido.length == 0) {

                    this.showAlert('É obrigatório atribuir ao menos um exame no agendamento.', 'Atenção')

                    return false
                }

                if (!this.verificaAutorizacao && !this.autoriza) {

                    this.handleVagas()

                    if (!this.disponivel) {

                        const confirm = async () => {

                            this.$refs.RkmModalPermissao.open()

                            return false
                        }

                        const cancel = async () => { this.handleExit }

                        const msg = `A quantidade de vaga para o horário selecionado foi atingida, para continuar é
                            necessário informar os dados do supervisor. Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)

                        return false
                    }
                }

                this.$emit('handleSaveAgendamento', this.exames, this.itemSelecionado, this.horarioAtendimento)

                this.$refs.RkmModalExames.hide()
            })
        },
        handleVagas() {

            this.disponivel = true

            let agendamentos = null

            let horarioSelecionado = this.horarioAtendimento

            if (!horarioSelecionado) {

                horarioSelecionado = this.itemSelecionado.horaInicial
            }

            this.jornadas.filter(item => item.data === this.itemSelecionado.data && item.horaInicial === horarioSelecionado).map(horario => {

                let vagas = Number(horario.vagas || 0) + Number(horario.vagasApp || 0)
                let horarioInicial = horario.horaInicial
                let tempoAtendimento = horario.tempoAtendimento

                horarioInicial = moment(horarioInicial, "HH:mm")
                    .subtract(tempoAtendimento, 'minutes')
                    .format('HH:mm');

                if (horario.tipoId == this.enums.tipoJornada.DINAMICA) {

                    for (let i = 0; i < vagas; i++) {

                        if (i !== this.tabIndex) {

                            horarioInicial = moment(horarioInicial, "HH:mm")
                                .add(tempoAtendimento, 'minutes')
                                .format('HH:mm');

                            if (horarioInicial == horarioSelecionado) {

                                agendamentos = this.vagas.filter(item =>
                                    item.data === this.itemSelecionado.data
                                    && item.horaInicial == horarioSelecionado
                                    && item.agendamentoId !== this.agendamento.agendamentoId).length

                                if (agendamentos > 0) {

                                    this.disponivel = false
                                }
                            }
                        }
                    }
                } else {

                    agendamentos = this.vagas.filter(item => item.data === this.itemSelecionado.data
                        && item.horaInicial == horarioSelecionado
                        && item.agendamentoId !== this.agendamento.agendamentoId).length

                    if (agendamentos >= vagas) {

                        this.disponivel = false
                    }
                }

                return this.disponivel
            })
        },
        getStringDiaSemana(dia) {

             if(dia == this.enums.diasSemana.DOMINGO) {

               return 'DOMINGO'
            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA) {

               return 'SEGUNDA-FEIRA'
            } else if (dia == this.enums.diasSemana.TERCA_FEIRA) {

               return 'TERÇA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA) {

               return 'QUARTA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA) {

               return 'QUINTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA) {

               return 'SEXTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SABADO) {

               return 'SÁBADO'
            }
        },
        handleSaldo(item) {

            this.cota = item

            if (this.regulacaoSolicitacao && !this.regulacaoSolicitacao.exameLaboratorialAgendamentoId) {

                this.$nextTick().then(() => this.$refs.Form.addExamesRegulados())
            }
        },
        saveModal(supervisorId){

            this.agendamento.supervisorId = supervisorId
            this.autoriza = true

            this.validate()
        },
    },
    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true},
        agendamento: { type: Object, required: true },
        jornadas: { type: Array, required: true },
        vagas: { type: Array, required: true },
        horarioAgendamento: { type: String, default: null },
        regulacaoSolicitacao: { type: Object },
        reagendar: { type: Object },
    },
    mixins: [ error, repository ],
}
</script>